module.exports = __webpack_public_path__ + "img/icon_guide.68644dc6.svg";